// extracted by mini-css-extract-plugin
export default {"lanscapeAboutLandscapeAddWrapper":"LandscapeAboutLandscapeEditPage_lanscapeAboutLandscapeAddWrapper__PbC7W"};